import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { DEFAULT_COLUMN, NETWORK_MODULE } from "../constant/networkConstant";

export const setNetworkPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: NETWORK_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
